import { isTextFile } from './fileTypeHelpers';
import { generatePdfThumbnail } from './pdfThumbnail';
import { generateTextThumbnail } from './textThumbnail';

/**
 * Generates a preview blob URL for a file (image, PDF, or text).
 * Rejects if preview generation fails or file type is unsupported.
 *
 * @param fileObject - The file to generate a preview for
 * @returns Promise resolving to blob URL
 * @throws Error if file type is unsupported or generation fails
 */
export async function generateFilePreview(fileObject: File): Promise<string> {
	if (fileObject.type === 'application/pdf') {
		return await generatePdfThumbnail(fileObject);
	} else if (fileObject.type.startsWith('image/')) {
		return URL.createObjectURL(fileObject);
	} else if (isTextFile(fileObject.type, fileObject.name)) {
		return await generateTextThumbnail(fileObject);
	}
	throw new Error(`Unsupported file type: ${fileObject.type}`);
}
